import { Link } from 'react-router-dom';

/**
 * StaticFooter Component
 * 
 * Reusable footer for logged-out pages (HomePage, WaitlistPage)
 * Contains privacy links and copyright - part of page, not app layout
 */
export default function StaticFooter() {
  const handleLinkClick = () => {
    // Scroll to top when navigating to legal/info pages
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full flex flex-col items-center gap-6 py-6 px-4">
      {/* Copyright */}
      <p className="text-xs text-text-muted">
        © 2025 ORO, LLC. All rights reserved.
      </p>
      
      {/* Footer Links */}
      <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs">
        <Link 
          to="/privacy" 
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Privacy
        </Link>
        <Link 
          to="/terms" 
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Terms
        </Link>
        <Link 
          to="/about" 
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          About
        </Link>
        <Link 
          to="/faq" 
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          FAQ
        </Link>
        <Link 
          to="/contact" 
          onClick={handleLinkClick}
          className="text-text-secondary hover:text-accent transition-colors min-h-11 flex items-center"
        >
          Contact
        </Link>
      </nav>
    </footer>
  );
}